import { useState } from 'react';
import { Form, Row, Col, Button, Card, Image } from 'react-bootstrap';
import ProfileMobileSectionActions from './ProfileMobileSectionActions';
import icMortarboard from './assets/img/ic-mortarboard.svg';
import icCalendar from './assets/img/ic-calendar.svg';

const UserAddCompany = ({ handleReset, formData, handleChange, isEditPage, handleStudyingInfoSubmit, hideEdit }) => {
    const [isEditing, setIsEditing] = useState(!isEditPage); // If adding, fields start enabled
    const [tempFormData, setTempFormData] = useState({ ...formData }); // Store initial values

    // Enable editing mode
    const handleEditClick = () => {
        setIsEditing(true);
        setTempFormData({ ...formData }); // Store previous values
    };

    // ✅ Save changes and disable editing
    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (typeof handleStudyingInfoSubmit === 'function') { // ✅ Ensure it's a function before calling
            await handleStudyingInfoSubmit(e);
            setIsEditing(false); // ✅ Exit edit mode after saving
        } else {
            console.error('Error: handleStudyingInfoSubmit is not a function.');
        }
    };

    // Cancel editing and restore previous values
    const handleCancelClick = () => {
        setIsEditing(false); // Exit edit mode

        if (typeof handleReset === 'function') {
            handleReset(tempFormData); // ✅ Restore saved values + clear errors
        }
    };

    return (
        <>
            <Card className="mb-4">
                <Card.Body>
                    {/* Title and Edit Button */}
                    <Row>
                        <Col>
                            <div className="profile-section-heading-row">
                            {isEditPage && !hideEdit && (
                                <div className="float-end d-none d-lg-block">
                                    {!isEditing ? (
                                        <Button variant="outline-secondary" className="btn-sm" onClick={handleEditClick}>Edit</Button>
                                    ) : (
                                        <>
                                            <Button variant="outline-secondary" className="btn-sm me-2" onClick={handleCancelClick}>Cancel</Button>
                                            <Button variant="primary" className="btn-sm" onClick={handleSaveClick}>Save</Button>
                                        </>
                                    )}
                                </div>
                            )}
                            <h3 className="company-detail-section-title d-lg-none"><span className="item-number">5.</span> Studying info</h3>
                            <h3 className="d-none d-lg-flex"><span className="item-number">5.</span> Studying info</h3>
                            </div>
                            <hr />
                        </Col>
                    </Row>
                    <>
                        {isEditing ? (
                            <>
                                <Row>
                                    {/* Form Fields */}
                                    <Col md={12}>
                                        <Row className="mb-3 profile-edit-fields">
                                            <Col md={4}>
                                                <Form.Group controlId="currentDegree">
                                                    <Form.Label>Current degree</Form.Label>
                                                    <Form.Select
                                                        name="currentDegree"
                                                        value={formData.currentDegree}
                                                        onChange={handleChange}
                                                        required
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    >
                                                        <option value="">Select degree...</option>
                                                        <option value="No degree">No degree</option>
                                                        <option value="High school diploma">High school diploma</option>
                                                        <option value="Vocational qualification">Vocational qualification</option>
                                                        <option value="Associate degree">Associate degree</option>
                                                        <option value="Bachelor's degree">Bachelor's degree</option>
                                                        <option value="Master's degree">Master's degree</option>
                                                        <option value="Doctorate (PhD)">Doctorate (PhD)</option>
                                                        <option value="Professional degree">Professional degree</option>
                                                        <option value="Postdoctoral qualification">Postdoctoral qualification</option>
                                                        <option value="Other">Other</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="futureDegree">
                                                    <Form.Label>Future degree</Form.Label>
                                                    <Form.Select
                                                        name="futureDegree"
                                                        value={formData.futureDegree}
                                                        onChange={handleChange}
                                                        required
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    >
                                                        <option value="">Select degree...</option>
                                                        <option value="No degree">No degree</option>
                                                        <option value="High school diploma">High school diploma</option>
                                                        <option value="Vocational qualification">Vocational qualification</option>
                                                        <option value="Associate degree">Associate degree</option>
                                                        <option value="Bachelor's degree">Bachelor's degree</option>
                                                        <option value="Master's degree">Master's degree</option>
                                                        <option value="Doctorate (PhD)">Doctorate (PhD)</option>
                                                        <option value="Professional degree">Professional degree</option>
                                                        <option value="Postdoctoral qualification">Postdoctoral qualification</option>
                                                        <option value="Other">Other</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="plannedGraduationYear">
                                                    <Form.Label>Planned year of graduation</Form.Label>
                                                    <Form.Select
                                                        name="plannedGraduationYear"
                                                        value={formData.plannedGraduationYear}
                                                        onChange={handleChange}
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    >
                                                        <option value="">Please Select</option>
                                                        {Array.from({ length: 6 }, (_, i) => {
                                                            const year = new Date().getFullYear() + i;
                                                            return (
                                                                <option key={year} value={year}>
                                                                    {year}
                                                                </option>
                                                            );
                                                        })}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            
                            </>
                        ) : (
                            <>
                                <Row className="mb-4">
                                    <Col md={4}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icMortarboard} alt="Current degree" />
                                            </span>
                                            <span className="text">
                                                Current degree
                                                <br />
                                                <strong>    
                                                    {formData.currentDegree || "N/A"}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icMortarboard} alt="Future degree" />
                                            </span>
                                            <span className="text">
                                                Future degree
                                                <br />
                                                <strong>    
                                                    {formData.futureDegree || "N/A"}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icCalendar} alt="Planned year of graduation" />
                                            </span>
                                            <span className="text rating">
                                                Planned year of graduation:
                                                <br />
                                                <strong>    
                                                    {formData.plannedGraduationYear || "N/A"}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                </Row>  
                            </>
                        )}
                    </>
                    <ProfileMobileSectionActions
                        isEditing={isEditing}
                        onEdit={handleEditClick}
                        onCancel={handleCancelClick}
                        onSave={handleSaveClick}
                        show={isEditPage && !hideEdit}
                    />
                </Card.Body>
            </Card>
        </>
    );
};

export default UserAddCompany
